import { Injectable, EventEmitter, Output, Directive } from "@angular/core";
// import { anyDialogOpenSelector } from "../../../app/broadband/_store/plans-selection/plans-selection.selectors";
import { Store } from "@ngrx/store";
// import { ModuleState } from "../../broadband/_store/module.state";

@Injectable({
	providedIn: "root"
})
export class HeaderToggleService {
	headerShow = true;
	private anyDialogOpen: boolean;

	@Output()
	change: EventEmitter<boolean> = new EventEmitter();

	constructor(private store: Store<any>) {
		// this.store.select(anyDialogOpenSelector).subscribe(val => {
		// 	this.anyDialogOpen = val;
		// });
	}

	toggle() {
		if (!this.anyDialogOpen) {
			this.headerShow = !this.headerShow;
			this.change.emit(this.headerShow);
		}
	}

	close() {
		this.headerShow = false;
		this.change.emit(this.headerShow);
	}

	open() {
		if (!this.anyDialogOpen) {
			this.headerShow = true;
			this.change.emit(this.headerShow);
		}
	}
}
